<template>
  <el-radio-group
    ref="rcRadioGroup"
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="slot in slots" :slot="componentSlot(slot)">
      <!-- 默认插槽 -->
      <slot v-if="isDefaultSlot(componentSlot(slot))" :name="slot">
        <el-radio
          v-for="item in options"
          :key="item.value || item.label"
          :label="complexValue(item)"
          v-bind="item"
          v-on="$listeners"
        >
          {{ item.label }}
        </el-radio>
      </slot>
      <!-- 自定义其他插槽 -->
      <slot v-else :name="slot"></slot>
    </template>
  </el-radio-group>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
export default {
  name: "RcRadioGroup",
  mixins: [slotMixins],
  props: {
    value: [String, Number, Boolean],
    options: {
      type: Array,
      default: () => []
    },
    slots: {
      type: Array,
      default: () => ["default"]
    }
  },
  computed: {
    complexValue() {
      return item => {
        if (typeof item.value !== "undefined") {
          return item.value;
        }

        return item.label;
      };
    }
  }
};
</script>
